<li
  role="option"
  class="dropdown-item"
  [class.dropdown-item--highlight]="selected"
  [id]="id"
  (click)="handleClickEvent($event)"
  (mouseenter)="handleMouseEnterEvent($event)"
>
  <span class="dropdown-label" *ngIf="!templateRef">
    <div *ngIf="option.limit">
      <badge icon="group">
        {{ option.limit?.current }} / {{ option.limit?.max }}
      </badge>
    </div>

    {{ (option.label | translate) ?? "empty" }}
  </span>

  <ng-container
    *ngTemplateOutlet="templateRef; context: { $implicit: option }"
  />
</li>
